<template>
  <div class="card" :class="{ selected: selected, disabled: disabled }" @click="handleSelect">
    <h4>
      <img :src="getElementIcon(item.type)" :alt="`${item.type}-icon`" />

      {{ item.name }}
    </h4>
    <p>{{ item.description }}</p>
  </div>
</template>

<script setup lang="ts">
import { ItemType, TemplateItemOption } from "@/@types/flows/emailTemplates/items";

const props = defineProps<{
  item: TemplateItemOption;
  selected: boolean;
  disabled: boolean;
}>();

const emit = defineEmits<{
  select: [item: TemplateItemOption];
}>();

const getElementIcon = (type: ItemType) => {
  return new URL(`../../assets/templateItemsIcons/${type}.svg`, import.meta.url).href;
};

const handleSelect = () => {
  if (props.disabled) return;

  emit("select", props.item);
};
</script>

<style scoped lang="sass">
h4, p
  margin: 0
  color: $gray-9
  font-size: 14px
  font-weight: 400

h4
  display: flex
  align-items: center
  gap: 4px

  img
    height: 18px
    width: 18px

p
  text-align: center
  margin: 0 20px
  color: $gray-8
  font-size: 12px

.card
  height: 100px
  border: 1px solid $gray-5
  border-radius: 8px
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)
  display: flex
  flex-direction: column
  gap: 5px
  align-items: center
  justify-content: center
  cursor: pointer
  user-select: none

  &:hover
    border-color: $blue-5

  &.selected
    border-color: $blue-5

  &.disabled
    cursor: not-allowed
    opacity: 0.5
    box-shadow: none
    background-color: $gray-3
    color: $gray-6

    &:hover
      border-color: $gray-5
</style>
